import { render } from "./keyForm.vue?vue&type=template&id=526a21ae"
import script from "./keyForm.vue?vue&type=script&lang=js"
export * from "./keyForm.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__